import { Card, Col, Row, Dropdown, Form, Badge, Alert, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useSalesforceStore from '../../../store/SalesforceStore';
// @ts-ignore
import './opportunityDocumentAreas.scss';
import { OpportunityCreditStatusEnum, OpportunityPageTabsEnum, OpportunityStageEnum, RoleEnum } from '../../../api/models/Enums';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useApiClient } from '../../../hooks/useApiClient';
import SpinnerButton from '../../SpinnerButton/SpinnerButton';
import i18next from 'i18next';
import OpportinityDocumentUploaderModal from '../OpportunityDocumentUploaderModal/OpportunityDocumentUploaderModal';
import _ from 'lodash';
import { GiCheckMark } from 'react-icons/gi';
import toaster from '../../../utils/toaster';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { translateOpportunityCreditStatus } from '../../../utils/translations';
import Spinner from 'react-bootstrap/Spinner';
import Btn from '../../Btn/Btn';
import OpportunityAttachments from '../Opportunity/OpportunityAttchments';
import { OpportunityAttachment } from '../../../api/models/AccountEntity';
import { downloadBase64File, formatDate } from '../../../utils';
import { AcademyAdvancedSearchRequestDTO, OptionDTO } from 'src/api';
import { FaCheck, FaDownload } from 'react-icons/fa';
import { FaAngleDown } from "react-icons/fa6";
import { Formik } from 'formik';
import RequiredFormLabel from 'src/components/RequiredFormLabel/RequiredFormLabel';
import { useErrorToast } from 'src/hooks/useErrorToast';
import { useAuth } from 'src/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import DocumentationFileUploaderModal from './DocumentationFileUploaderModal';
import OpportunityFilePreviewModal from './OpportunityFilePreviewModal';
import { Storage } from 'aws-amplify';


interface Document {
  label: string;
  value: string;
  is_uploaded: boolean;
  uploadedFileName?: string;
  className?: string;
  createdAt?: string | null;
}

const LegacyOpportunityCreditDocument = ({ data, opportunityCreditDataLoading, className, setShowVehicleNotAvailableModal, isVehicleUnavailable, isOpportunityReadOnly }) => {
  const { t } = useTranslation();
  const [creditStatus, setCreditStatus] = useState<string>(t("select_state"));
  const { opportunityData, accountSalesforce, setUploadCreditFileClicked } = useSalesforceStore();
  const [showUploadDocsModal, setShowUploadDocsModal] = useState<boolean>(false);
  const [updating, setUpdating] = useState<boolean>(false);
  const { apiClient, handleApiResponse } = useApiClient();
  const [documentationFolder, setDocumentationFolder] = useState<Document[]>([]);
  const queryClient = useQueryClient();
  const [downloadingAttachment, setDownloadingAttachment] = useState<string | null>(null);
  const [removingAttachment, setRemovingAttachment] = useState<string | null>(null);
  const [showUploadSingleDocModal, setShowUploadSingleDocModal] = useState<boolean>(false);
  const [filePreview, setFilePreview] = useState<{ isOpen: boolean; attachment?: any }>({ isOpen: false });
  const { showError } = useErrorToast();
  const navigate = useNavigate();

  const { mutateAsync: changeCreditStatus, isPending: changeCreditStatusPending } = useMutation({
    mutationFn: async (newStatus: string) => {
      return await apiClient.salesforceOpportunityController.changeCreditStatus(opportunityData?.Id, newStatus);
    },
    onSuccess: async (data, newStatus) => {
      try {
        toaster.success(t('credit_status_updated', { status: t(newStatus, newStatus) }));
      } catch (error) {
        console.warn(error);
      }
    },
    onError: (error) => {
      console.error('Error adding message:', error);
      toaster.error(t('failed_to_add_message'));
    },
  });
  const { userRole } = useAuth();

  const downloadAttachment = async (a: OpportunityAttachment) => {
    setDownloadingAttachment(a.Id);
    const presignedReponse = await handleApiResponse(apiClient.salesforceOpportunityController.getOpportunityAttachment(a.Id));

    if (presignedReponse && presignedReponse.downloadUrl) {
      const link = document.createElement('a');
      link.href = presignedReponse.downloadUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setDownloadingAttachment(null);
  };

  const downloadLoadedDocument = async (doc: Document) => {
    const attachment = opportunityData.attachments.find((item) => item.Title === doc.uploadedFileName)
    const isPdf = attachment?.Title?.endsWith('.pdf');
    attachment && downloadAttachment(attachment)
  }

  const previewAttachment = async (attachment?: OpportunityAttachment) => {
    if (!attachment) return;
    try {
      setDownloadingAttachment(attachment.Id);

      const notPdf = !attachment?.Title?.endsWith('.pdf');
      const presignedReponse = await handleApiResponse(apiClient.salesforceOpportunityController.getOpportunityAttachment(attachment.Id));

      if (!presignedReponse?.downloadUrl) {
        console.warn('No download url for attachment ', attachment);
        return;
      }

      if (notPdf) {
        const link = document.createElement('a');
        link.href = presignedReponse.downloadUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return;
      }

      setFilePreview({ isOpen: true, attachment: { ...attachment, url: presignedReponse.downloadUrl } })
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadingAttachment(null);
    }
  }

  const mapFolderTitle = (input: string): string => {
    const folderMapping: { [key: string]: string } = {
      Azienda: 'AZIENDE (SOCIETÀ DI CAPITALI)',
      Libero_Professionista: 'LIBERI PROFESSIONISTI/SOCIETÀ DI PERSONE',
      'Libero Professionista': 'LIBERI PROFESSIONISTI/SOCIETÀ DI PERSONE',
      Privato: 'PRIVATI',
    };
    return folderMapping[input] || '';
  };

  const buildAdvancedSearchPayload = (accountSalesforce?: any, opportunityData?: any): AcademyAdvancedSearchRequestDTO => {
    if (!accountSalesforce || !opportunityData) {
      return {} as AcademyAdvancedSearchRequestDTO;
    }

    const translations = {
      noleggiatori: ['NOLEGGIATORI', 'RENTAL OPERATORS', 'AGENTES DE ALQUILER'],
      documentazione: ['DOCUMENTAZIONE', 'DOCUMENTATION', 'DOCUMENTACIÓN'],
    };

    const payload: AcademyAdvancedSearchRequestDTO = {
      "title": "TEMPLATES",
      "isActive": true,
      "folderLevels": {
        "0": {
          "eqTitle": "root"
        },
        "1": {
          "inTitles": translations.noleggiatori
        },
        "2": {
          "inTitles": translations.documentazione
        },
        "3": {
          "eqTitle": opportunityData?.Noleggiatore__c
        },
        "4": {
          "eqTitle": mapFolderTitle(accountSalesforce?.RecordType?.Name || '')
        }
      }
    }
    return payload
  }

  useEffect(() => {
    if (data && data?.statoCredito) {
      setCreditStatus(OpportunityCreditStatusEnum[data?.statoCredito] || t('select_state'))
    }
  }, [data, t])

  useEffect(() => {
    const fetchAreaAcademy = async () => {
      try {
        if (!opportunityData?.Noleggiatore__c) return;

        const payload = buildAdvancedSearchPayload(accountSalesforce, opportunityData)
        if (!payload.title?.trim()) return;

        const folders = await handleApiResponse(
          apiClient.areaAcademyController.advancedSearch(payload)
        );

        const docs: Document[] = [];
        const folderContent = folders?.[0]?.data || [];

        for (const item of folderContent) {
          if (item.type === "folder") {
            continue;
          }
          const fileNameWithoutExtension = item.title.split('.')[0].trim().toLowerCase();
          const uploadedDoc = data?.loadedDocuments?.find((doc) => doc?.fileType?.trim().toLowerCase() === fileNameWithoutExtension)
          const isUploaded = Boolean(uploadedDoc);

          docs.push({
            label: item.title,
            value: item.id,
            is_uploaded: isUploaded,
            createdAt: uploadedDoc?.createdAt,
            uploadedFileName: isUploaded ? uploadedDoc.fileName : null,
          })
        }
        setDocumentationFolder(docs);
      } catch (err) {
        console.error('Error in fetchAreaAcademy:', err);
      }
    };

    fetchAreaAcademy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountSalesforce, opportunityData, data]);

  const downloadAllDocuments = () => {
    handleApiResponse(apiClient.salesforceOpportunityController.downloadAllDocuments(opportunityData.Id))
      .then((res) => {
        if (res && res.downloadUrl) {
          // Create a temporary link and trigger download in a new tab
          const link = document.createElement('a');
          link.href = res.downloadUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {
        console.error('Error downloading all documents:', err);
        toaster.error(t('error_downloading_documents'));
      });
  }

  const deriveStateButtonText = () => {
    if (updating) {
      return <Spinner animation="border" role="output" size="sm" />;
    }
    if (changeCreditStatusPending) {
      return <Spinner animation="border" role="output" size="sm" />;
    }
    return translateOpportunityCreditStatus(creditStatus);
  };

  const trackChangeStateTime = () => {
    try {
      localStorage.setItem(`lastChangedStateTime`, Date.now().toString());
    } catch (error) {/* ignore */ }
  }

  const onChangeCreditStatus = async (newStatus: string) => {
    if (newStatus === data?.statoCredito) {
      return;
    }

    if (newStatus === OpportunityCreditStatusEnum.credit_sent && isVehicleUnavailable) {
      const oppNewStage = OpportunityCreditStatusEnum.credit_sent === newStatus
        ? OpportunityStageEnum.credit_score_check
        : null;

      setShowVehicleNotAvailableModal?.(true, oppNewStage)
      return;
    }

    setUpdating(true);
    try {
      await changeCreditStatus(newStatus);
      trackChangeStateTime();
      if (newStatus === OpportunityCreditStatusEnum.credit_sent && opportunityData?.ID_Vehicle_HMP__c) {
        const optionRequest: OptionDTO = {
          cliente: accountSalesforce?.Name,
          opportunityId: opportunityData.Id,
          vehicleId: opportunityData.ID_Vehicle_HMP__c,
          ragione_sociale: accountSalesforce.Codice_Fiscale__c || accountSalesforce.Partita_IVA__c || '',
          noleggiatore: opportunityData.Noleggiatore__c || '',
          document: [],
        };
        await handleApiResponse(
          apiClient.vehicleActionsController.postVehiclesActions(optionRequest)
        );
      }
      setCreditStatus(OpportunityCreditStatusEnum[newStatus as keyof typeof OpportunityCreditStatusEnum]);
      await queryClient.invalidateQueries({ queryKey: ['opportunityCreditData'] });
      navigate(0);
    } catch (error) {
      console.error('Error updating credit status:', error);
      toaster.error(t('failed_to_update_credit_status'));
    } finally {
      setUpdating(false);
    }
  }

  /**
   * Il campo IBAN dovrà essere compilabile in fondo alla checklist, salvato sul DB HMP e non su SF.
   * Se viene selezionato il noleggiatore Alphabet il campo viene nascosto perché è presente il documento “IBAN su carta intestata”
   */
  const isIbanFieldAllowed = useMemo(() => {
    const noleggiatore = opportunityData?.Noleggiatore__c?.trim();
    return !['alphabet'].includes(_.lowerCase(noleggiatore));
  }, [opportunityData])

  const submitIban = async (values: { iban?: string | null }) => {
    try {
      setUpdating(true);
      const ibanValue = values?.iban?.trim() || '';
      const complete = (!!values?.iban?.trim() && isCompleteWithoutIban) ? true : undefined;
      await handleApiResponse(apiClient.salesforceOpportunityController.updateBackofficeDetails(
        opportunityData.Id,
        ibanValue,
        complete
      ));
      toaster.success(t('modify_success'));
      queryClient.invalidateQueries({ queryKey: ['opportunityData'] });
      queryClient.invalidateQueries({ queryKey: ['opportunityCreditData'] });
    } catch (error) {
      showError(error, t('error_editing_opportunity'))
    } finally {
      setUpdating(false);
    }
  }

  const initialIbanFormValues = useMemo(() => {
    return { iban: data?.iban || '' };
  }, [data?.iban])

  const hasAllDocuments = useCallback((files) => {
    if (!documentationFolder || !documentationFolder.length) {
      return undefined;
    }

    if (isIbanFieldAllowed && !data?.iban?.trim()) {
      return false;
    }

    const missing = (documentationFolder || []).filter((item) => !item.is_uploaded);
    const uploadingFileTypes = (files || []).map(upFile => upFile.fileType?.trim().toLowerCase());

    const isComplete = missing.every((missingFile) =>
      uploadingFileTypes.includes(missingFile.label.split('.')[0].trim().toLowerCase())
    )

    if (!missing?.length) {
      return false;
    }

    return isComplete;
  }, [documentationFolder, data])

  const removeAttachment = async (a: OpportunityAttachment) => {
    try {
      setRemovingAttachment(a.Id);
      await handleApiResponse(apiClient.salesforceOpportunityController.removeOpportunityAttachment(a.ContentDocumentId));
      queryClient.invalidateQueries({ queryKey: ['opportunityData'] });
      queryClient.invalidateQueries({ queryKey: ['opportunityCreditData'] });
    } catch (error) {
      showError(error, t('error_removing_attachment'));
    } finally {
      setRemovingAttachment(null);
    }
  };

  const downloadAcademyDocuments = () => {
    const queryParams = {
      nomeNoleggiatore: opportunityData?.Noleggiatore__c,
      tipoCliente: mapFolderTitle(accountSalesforce?.RecordType?.Name || ''),
    };
    handleApiResponse(apiClient.areaAcademyController.downloadRentalDocuments(queryParams))
      .then((res) => {
        if (res && res.presignedUrl) {
          const link = document.createElement('a');
          link.href = res.presignedUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {
        showError(err, t('error_downloading_documents'));
      });
  }

  const canViewUploadDate = [RoleEnum.ADMIN, RoleEnum.BACKOFFICE, RoleEnum.MASTER, RoleEnum.SALES, RoleEnum.SALES_DEALER, RoleEnum.SALES_INTERNAL, RoleEnum.AREA_MANAGER, RoleEnum.SEGNALATORE].includes(userRole)

  const isCompleteWithoutIban = useMemo(() => {
    if (!documentationFolder || !documentationFolder.length) {
      return undefined;
    }

    const missing = (documentationFolder || []).filter((item) => !item.is_uploaded);
    if (missing.length) {
      return false;
    }

    return missing?.length === 0 && isIbanFieldAllowed && !data?.iban;
  }, [data, documentationFolder]);

  const missingIbanAlert = (
    <Alert variant="warning">
      {i18next.t('iban_required_alert_message')}
    </Alert>
  )

  const parseChecklistItemLabel = (file: Document) => {
    const extensions = ['.doc', '.docx', '.pdf', '.png', '.tiff', '.jpg', '.jpeg', '.gif', '.bmp', '.txt', '.xls', '.xlsx', '.ppt', '.pptx', '.zip', '.rar'];
    const regex = new RegExp(`(${extensions.map(ext => ext.replace('.', '\\.')).join('|')})+$`, 'i');
    return file.label?.replace(regex, '');
  }

  return (
    <Card className={'mb-4 ' + className || ''}>
      <Card.Body>
        <Card.Subtitle className="mb-2 mt-2 d-flex align-items-center justify-content-between fs-5">
          <div className="fw-bold">{t('credit_management')}</div>
          <Row>
            <Col>
              <Dropdown className="ms-1 align-text-bottom d-inline-block action-dropdown">
                <Dropdown.Toggle
                  disabled={[RoleEnum.SALES, RoleEnum.SALES_DEALER, RoleEnum.SALES_INTERNAL, RoleEnum.SEGNALATORE].includes(userRole) || isOpportunityReadOnly}
                  className="btn">
                  {deriveStateButtonText()}
                  <FaAngleDown style={{ width: 20, height: 20 }} className='ms-2' />
                </Dropdown.Toggle>
                <Dropdown.Menu className="position-fixed">
                  {Object.keys(OpportunityCreditStatusEnum).map((status) => (
                    <Dropdown.Item
                      key={status}
                      className="d-flex align-items-start justify-content-between"
                      disabled={status === OpportunityCreditStatusEnum.credit_sent && [OpportunityStageEnum.closed_by_credit_score_check, OpportunityStageEnum.closed_won].includes(opportunityData.StageName)}
                      onClick={() => onChangeCreditStatus(status)}
                    >
                      <div>
                        {translateOpportunityCreditStatus(status)}
                      </div>
                      {status === data?.statoCredito ? <FaCheck /> : null}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Card.Subtitle>
        <hr />

        <div className="my-4 d-flex align-items-center justify-content-between">
          <div className="fw-bold">{t('checklist_documents')}</div>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="d-flex btn p-0 border-0 bg-transparent"
              title={t('download_all')}
              onClick={downloadAllDocuments}
            >
              <div className="fw-bold">{t('download_all')}</div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9 2a1 1 0 0 1 2 0v8.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4A1 1 0 1 1 6.707 8.293L9 10.586V2z" />
                <path d="M3 16a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z" />
              </svg>
            </button>
          </div>
        </div>

        {documentationFolder.map((file, index) => (
          <Row key={index} className="align-items-center mb-2">
            <Col md="auto">
              {opportunityCreditDataLoading ? (
                <SpinnerButton busy={opportunityCreditDataLoading} label="" />
              ) : (
                <>
                  <div className="d-flex align-items-center">
                    {file.is_uploaded && <GiCheckMark className="text-success me-2" />}
                    <span className="me-2">{parseChecklistItemLabel(file)}</span>
                  </div>
                  {file.is_uploaded ? (
                    <span
                      className="text-decoration-underline ms-4"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        const attachment = opportunityData?.attachments?.find((item) => item.Title === file.uploadedFileName);
                        previewAttachment(attachment);
                      }}
                    >
                      ({file.uploadedFileName})
                    </span>
                  ) : null}
                </>
              )}
            </Col>

            <Col className="ms-auto" md="auto">
              {canViewUploadDate && file.createdAt
                ? <Badge bg="secondary" className="m-2">{formatDate(file.createdAt, 'it-IT', true)}</Badge>
                : null
              }
              {file.is_uploaded && (
                <Button
                  variant="link"
                  onClick={() => downloadLoadedDocument(file)}
                >
                  <FaDownload />
                </Button>)
              }
              <Btn
                disabled={isOpportunityReadOnly}
                onClick={() => {
                  setUploadCreditFileClicked(file.label.split('.')[0]);
                  setShowUploadSingleDocModal(true)
                }}
              >
                <SpinnerButton label={i18next.t('upload')} busy={false} />
              </Btn>
            </Col>
          </Row>
        ))}
        {isIbanFieldAllowed ?
          <Formik
            key={data?.iban}
            initialValues={initialIbanFormValues}
            onSubmit={submitIban}
          >
            {({ values, handleChange, handleSubmit, isSubmitting }) => (
              <Form autoComplete='off' onSubmit={handleSubmit}>
                <Row className="mt-3 align-items-end">
                  {(isIbanFieldAllowed && isCompleteWithoutIban) ? missingIbanAlert : null}
                  <Col md={8}>
                    <Form.Group className="mb-3 iban-input">
                      <RequiredFormLabel label={i18next.t('iban')} />
                      <Form.Control
                        disabled={isOpportunityReadOnly}
                        id="opportunity.iban"
                        name="iban"
                        type="text"
                        placeholder={i18next.t('iban_required_placeholder')}
                        onChange={handleChange}
                        value={values?.iban || ""}
                      />
                    </Form.Group>
                  </Col >
                  <Col md={4}>
                    <Btn
                      type="submit"
                      className="float-end mb-3"
                      disabled={isSubmitting || isOpportunityReadOnly}
                    >
                      {i18next.t('save')}
                    </Btn>
                  </Col>
                </Row >
              </Form>
            )}
          </Formik>
          : null}
        <hr />
        <Row className="my-4 d-flex align-items-center justify-content-between">
          <div className="fw-bold">{t('academy_download_documents')}</div>
          <div className="mt-2 d-flex align-items-center">
            <button
              type="button"
              className="d-flex btn p-0 border-0 bg-transparent"
              title={t('download_documents')}
              onClick={downloadAcademyDocuments}
            >
              <div className="text-decoration-underline">{t('download_documents')}</div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                viewBox="0 0 20 20"
                className="ms-1"
              >
                <path d="M9 2a1 1 0 0 1 2 0v8.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4A1 1 0 1 1 6.707 8.293L9 10.586V2z" />
                <path d="M3 16a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z" />
              </svg>
            </button>
          </div>
        </Row>
        <hr />
        <OpportunityAttachments
          isLegacy={true}
          opportunityResponse={opportunityData}
          loadedDocuments={documentationFolder}
          updating={updating}
          setShowUploadDocsModal={setShowUploadDocsModal}
          downloadingAttachment={downloadingAttachment}
          downloadAttachment={downloadAttachment}
          removeAttachment={removeAttachment}
          removingAttachment={removingAttachment}
          previewAttachment={(attachment) => previewAttachment(attachment)}
        />

      </Card.Body>

      <OpportinityDocumentUploaderModal
        show={showUploadDocsModal}
        hasAllDocuments={hasAllDocuments}
        opportunity={opportunityData ?? undefined}
        onHide={() => {
          setUploadCreditFileClicked("")
          setShowUploadDocsModal(false);
        }}
        onSuccess={() => {
          setShowUploadDocsModal(false);
          queryClient.invalidateQueries({ queryKey: ['opportunityData'] });
          queryClient.invalidateQueries({ queryKey: ['opportunityCreditData'] });
          setUploadCreditFileClicked("")
        }}
        from={OpportunityPageTabsEnum.DOCUMENTS}
      />

      <DocumentationFileUploaderModal
        show={showUploadSingleDocModal}
        hasAllDocuments={hasAllDocuments}
        opportunity={opportunityData ?? undefined}
        onHide={() => {
          setShowUploadSingleDocModal(false)
          setUploadCreditFileClicked("")
        }}
        onSuccess={() => {
          setShowUploadSingleDocModal(false);
          queryClient.invalidateQueries({ queryKey: ['opportunityData'] });
          queryClient.invalidateQueries({ queryKey: ['opportunityCreditData'] });
          setUploadCreditFileClicked("")
        }}
      />

      <OpportunityFilePreviewModal
        isOpen={filePreview.isOpen}
        closePreview={() => setFilePreview({ isOpen: false })}
        attachment={filePreview.attachment}
      />

    </Card>
  );
};

export default LegacyOpportunityCreditDocument;
